module.exports = __webpack_public_path__ + "img/14.b5d11c5d.png";